/** Topbar — 1:1 port z chrome.jsx.
 *  h56, search 320px, bell s gold dot, avatar 32x32 gradient gold. */

import { Ic } from "@/components/ui/icons";
import { useAuth } from "@/auth/auth-provider";

export function Topbar() {
  const { partner } = useAuth();
  const initials = (partner?.company_name || partner?.contact_name || "  ")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s[0]?.toUpperCase() || "")
    .join("");

  return (
    <header
      style={{
        height: 56,
        padding: "0 24px",
        borderBottom: "1px solid var(--border)",
        display: "flex",
        alignItems: "center",
        gap: 16,
        background: "var(--bg-base)",
        flexShrink: 0,
      }}
    >
      <div style={{ flex: 1, display: "flex", alignItems: "center", gap: 12 }}>
        <div style={{ position: "relative", width: 320 }}>
          <span
            style={{
              position: "absolute",
              left: 12,
              top: "50%",
              transform: "translateY(-50%)",
              color: "var(--text-3)",
            }}
          >
            <Ic.Search size={14} />
          </span>
          <input
            className="input"
            placeholder="Auftrag, Kunde, Rechnung suchen…"
            style={{ height: 34, paddingLeft: 36, fontSize: 13 }}
          />
        </div>
      </div>

      <button type="button" className="btn btn-ghost btn-sm" style={{ position: "relative" }}>
        <Ic.Bell size={16} />
        <span
          style={{
            position: "absolute",
            top: 4,
            right: 4,
            width: 6,
            height: 6,
            borderRadius: 999,
            background: "var(--gold)",
            boxShadow: "0 0 8px var(--gold-glow)",
          }}
        />
      </button>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
          paddingLeft: 12,
          borderLeft: "1px solid var(--border)",
        }}
      >
        <div
          style={{
            width: 32,
            height: 32,
            borderRadius: 8,
            background: "linear-gradient(135deg, var(--gold), var(--gold-lo))",
            color: "#1A1408",
            fontWeight: 700,
            fontSize: 13,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {initials || "··"}
        </div>
        <div style={{ lineHeight: 1.2 }}>
          <div style={{ fontSize: 13, fontWeight: 500 }}>
            {partner?.company_name || partner?.contact_name || "—"}
          </div>
          <div style={{ fontSize: 11, color: "var(--text-3)" }}>
            {partner?.contact_name || partner?.email || ""}
          </div>
        </div>
      </div>
    </header>
  );
}
